import { render } from "./Team_adviser_en_m.vue?vue&type=template&id=9e8e1a88&scoped=true"
import script from "./Team_adviser_en_m.vue?vue&type=script&lang=js"
export * from "./Team_adviser_en_m.vue?vue&type=script&lang=js"

import "./Team_adviser_en_m.vue?vue&type=style&index=0&id=9e8e1a88&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9e8e1a88"

export default script